var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.className }, [
    _c(
      "div",
      {
        ref: "continueModal",
        staticClass: "reveal",
        attrs: { id: "continueModal", "data-reveal": "" },
      },
      [
        _c("div", { staticClass: "tender-confirm clearfix" }, [
          _c("p", { staticClass: "msg_hint" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.warnMessage || _vm.$t("warn.leave.lost")) +
                "\n      "
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "tender-confirm-button-bar row align-right nav_btn",
            },
            [
              _c(
                "button",
                {
                  staticClass: "btn btn--darkblue",
                  attrs: { id: "confirm_no", type: "button" },
                  on: {
                    click: function ($event) {
                      return _vm.cancelLeave()
                    },
                  },
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("action.cancel")) +
                      "\n        "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn--orange",
                  attrs: { id: "confirm_yes", type: "button" },
                  on: {
                    click: function ($event) {
                      return _vm.continueTo()
                    },
                  },
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("action.continue")) +
                      "\n        "
                  ),
                ]
              ),
            ]
          ),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }